<script>
	import { navigate } from "svelte-routing";

	export let row = {};
	export let key = "";

	let { linkBy, linkTo } = $$props;
</script>

<span
	class="link link-text"
	as="button"
	on:click={() => navigate(`${linkTo}${row[linkBy]}`)}
	on:keydown={() => {}}
>
	{row[key]}
</span>
